// @TODO: organize better? combine with utilities?
/**
 * Ryan O'Dowd
 * 2022-12-26
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Alert,
} from 'react-native';
import fb from '@utils/firebase';
import {
  fetchUser,
} from '@utils/store/actions';
import {
  store,
} from '@utils/store';

function memoAreEqual(prevProps, nextProps) {
  for (const pk in nextProps) {
    if (['function', 'boolean', 'number', 'string', 'symbol', 'bigint', 'undefined'].includes(typeof nextProps[pk])) {
      if (prevProps[pk] !== nextProps[pk]) {
        return false;
      }
    } else if (Array.isArray(nextProps[pk])) {
      /* @TODO:
      if (prevProps[pk]?.length !== nextProps[pk].length) {
        return false;
      }
      */
      if (JSON.stringify(prevProps[pk]) !== JSON.stringify(nextProps[pk])) {
        return false;
      }
    } else if (typeof nextProps[pk] === 'object') {
      if (JSON.stringify(prevProps[pk]) !== JSON.stringify(nextProps[pk])) {
        return false;
      }
    } else {
      // @TODO: what other types are there? throw error
      return false;
    }
  }

  return true;
}

function camelCaseToHumanReadable(s) {
  let retVal = s.replace(/([A-Z])/g, ' $1');
  retVal = `${retVal[0].toUpperCase()}${retVal.slice(1)}`;
  return retVal;
}

function isSecondOlderOrSameAsFirst(firstVersion, secondVersion) {
  if (!firstVersion || !secondVersion) {
    return true;
  }

  try {
    const [fvMajor, fvMinor, fvPatch] = firstVersion.split('.');
    const [svMajor, svMinor, svPatch] = secondVersion.split('.');
    if (+fvMajor > +svMajor) {
      return true;
    } else if (+fvMajor === +svMajor && +fvMinor > +svMinor) {
      return true;
    } else if (+fvMajor === +svMajor && +fvMinor === +svMinor && +fvPatch >= +svPatch) {
      return true;
    }
  } catch (e) {
    fb.recordError(fb.crashlytics, e);
  }

  return false;
}

export function linkUserAndCredential(user, credential, navigation) { // @TODO: i18n this function // @TODO: polyfill (ish) alert, then combine with web
  return fb.linkWithCredential(user, credential).then(() => {
    Alert.alert( // @TODO: replace with dialog
      'Success!', // @TODO: i18n
      'Account linked successfully.', // @TODO: i18n
      /* @TODO:
      success: {
        en: 'Success!',
        es: '¡Éxito!',
      },
      accountLinkedSuccessfully: {
        en: 'Account linked successfully.',
        es: 'Cuenta vinculada con éxito.',
      },
      */
      [
        {
          text: 'OK',
          onPress: () => {
            // update user in back end and redux store
            store.dispatch(fetchUser());
            navigation.goBack();
          },
        },
      ],
    );
    fb.logEvent(fb.analytics, 'linked_anonymous_account', {providerId: credential.providerId});
  }).catch((error) => { // @TODO: i18n these (combine with CustomAuthForm/index.tsx)
    let errorMessage = 'Account could not be linked; please try again.';
    switch (error.code) {
      case 'auth/provider-already-linked': // Thrown if the provider has already been linked to the user. This error is thrown even if this is not the same provider's account that is currently linked to the user.
        errorMessage = 'Account has already been linked.';
        break;
      case 'auth/credential-already-in-use': // Thrown if the account corresponding to the credential already exists among your users, or is already linked to a Firebase User. For example, this error could be thrown if you are upgrading an anonymous user to a Google user by linking a Google credential to it and the Google credential used is already associated with an existing Firebase Google user. The fields error.email, error.phoneNumber, and error.credential (AuthCredential) may be provided, depending on the type of credential. You can recover from this error by signing in with error.credential directly via auth#signInWithCredential.
        errorMessage = 'An existing account is already associated with this authentication provider.';
        break;
      case 'auth/email-already-in-use': // Thrown if the email corresponding to the credential already exists among your users. When thrown while linking a credential to an existing user, an error.email and error.credential AuthCredential fields are also provided. You have to link the credential to the existing user with that email if you wish to continue signing in with that credential. To do so, call Auth#fetchProvidersForEmail, sign in to error.email via one of the providers returned and then User#linkWithCredential the original credential to that newly signed in user
        errorMessage = 'An existing account is already associated with this email address.';
        break;
      case 'auth/weak-password': {
        errorMessage = 'Password must be at least 6 characters.';
        break;
      }
      case 'auth/network-request-failed': {
        errorMessage = 'Network error; please check connection and try again.';
        break;
      }
      // case 'auth/invalid-credential': // Thrown if the provider's credential is not valid. This can happen if it has already expired when calling link, or if it used invalid token(s). See the Firebase documentation for your provider, and make sure you pass in the correct parameters to the credential method.
      // case 'auth/operation-not-allowed': // Thrown if you have not enabled the provider in the Firebase Console. Go to the Firebase Console for your project, in the Auth section and the Sign in Method tab and configure the provider.
      // case 'auth/invalid-email': // Thrown if the email used in a EmailAuthProvider#credential is invalid.
      // case 'auth/wrong-password': // Thrown if the password used in a EmailAuthProvider#credential is not correct or when the user associated with the email does not have a password.
      // case 'auth/invalid-verification-code': // Thrown if the credential is a PhoneAuthProvider#credential and the verification code of the credential is not valid.
      // case 'auth/invalid-verification-id': // Thrown if the credential is a PhoneAuthProvider#credential and the verification ID of the credential is not valid.
      default: {
        fb.recordError(fb.crashlytics, error);
      }
    }
    Alert.alert( // @TODO: replace with dialog
      'Error',
      errorMessage,
      [
        {text: 'OK', onPress: () => {}},
      ],
    );
  });
}

export default {
  camelCaseToHumanReadable,
  isSecondOlderOrSameAsFirst,
  memoAreEqual,
  linkUserAndCredential: linkUserAndCredential,
};
